export default function initSelectLocation() {
  const selectLocation = document.querySelectorAll('[data-select-for="location-select"]');
  const locationInfoWraps = document.querySelectorAll('.location-info-wrap');
  const locationTabs = document.querySelectorAll('[data-tabs="location-tabs"] a');
  const cityButtons = document.querySelectorAll('.location-list');

  if (!selectLocation.length || !locationInfoWraps.length || !locationTabs.length) return;

  selectLocation.forEach((select) => {
    jQuery(select).prop('disabled', true);
  });

  locationInfoWraps.forEach((wrap) => {
    wrap.style.display = 'none';
  });

  const resetLocationItems = (wrap) => {
    wrap.querySelectorAll('.location-info-item').forEach((item) => {
      item.classList.remove('active');
    });
  };

  cityButtons.forEach((button) => {
    button.addEventListener('click', () => {
      // Enable all selects when a city is selected
      selectLocation.forEach((select) => {
        jQuery(select).prop('disabled', false);
      });
    });
  });

  locationTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      selectLocation.forEach((select) => {
        jQuery(select).prop('disabled', true).val('').trigger('change');
      });

      locationInfoWraps.forEach((wrap) => {
        resetLocationItems(wrap);
        wrap.style.display = 'none';
      });
    });
  });

  selectLocation.forEach((select, index) => {
    const locationInfoWrap = locationInfoWraps[index];

    jQuery(select).on('select2:select', (e) => {
      const selectedValue = e.params.data.id;

      locationInfoWrap.style.display = 'block';

      resetLocationItems(locationInfoWrap);

      if (selectedValue) {
        const selectedItem = locationInfoWrap.querySelector(`#${selectedValue}`);
        selectedItem?.classList.add('active');

        const activeTabContent = document.querySelector('.map-filters .tabs-content.is-active');
        if (activeTabContent) {
          const newHeight = activeTabContent.scrollHeight;
          activeTabContent.style.height = `${newHeight}px`;

          const tabsWrapElement = activeTabContent.closest('.map-filters .tabs-wrap');
          if (tabsWrapElement) {
            tabsWrapElement.style.height = `${newHeight}px`;
          }
        }
      }
    });

    jQuery(select).on('select2:clear', () => {
      resetLocationItems(locationInfoWrap);
      locationInfoWrap.style.display = 'none';

      const activeTabContent = document.querySelector('.map-filters .tabs-content.is-active');
      if (activeTabContent) {
        const dropdownHeight = activeTabContent.querySelector('.location-dropdown')?.offsetHeight || 0;
        activeTabContent.style.height = `${dropdownHeight}px`;

        const tabsWrapElement = activeTabContent.closest('.map-filters .tabs-wrap');
        if (tabsWrapElement) {
          tabsWrapElement.style.height = `${dropdownHeight}px`;
        }
      }
    });
  });
}
